import { runInAction, makeAutoObservable } from "mobx";
import {
  AuthenticatorQRcodeInfo,
  IAuthenticatorFormValues,
  IChangePwdFormValues,
  IOtpFormValues,
  IResetPwdFormValues,
  IUser,
  IUserConfirmResetPwdValues,
  IUserFormValues,
  IUserProfile,
  IUserProfileFormValues,
  LoginAuthenticatorApp,
  RegistrationFormValues,
} from "../models/user";
import agent from "../api/agent";
import { RootStore } from "./rootStore";
import { history } from "../..";
import { toast } from "react-toastify";
import { updateAppUser } from "../sqlite/utilities";
import { getToastTranslation } from "../helpers/translationHelper";
import { changePrincipalLanguage } from "../localization/localization";

export default class UserStore {
  rootStore: RootStore;
  inactivityTimeout : any;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this);
  }

  user: IUser | null = null;
  profile: IUserProfile | null = null;
  loadingProfile = false;
  loadingGroups = false;
  isChangePwdOpen = false;
  nearToLogout = false;
  lastUserActivity = localStorage.getItem('lastActivity') || "";
  loginAuthenticatorApp : LoginAuthenticatorApp | null = null;
  authenticatorQRcodeInfo : AuthenticatorQRcodeInfo | null = null;
  authenticatorAppResetToken = "";

  get isLoggedIn() {
    return !!this.user;
  }

  activateLogoutTimer(threshold? : number) {
    let inactivityThresholds = this.rootStore.tenantStore.currentTenant?.inactivityThresholds;
    if(!inactivityThresholds || inactivityThresholds === 0 || inactivityThresholds === 1)
      return;
    // Se il timer è già attivo, annulla l'attuale timer
      if (this.inactivityTimeout) {
          clearTimeout(this.inactivityTimeout);
      }
      let InactivityThresholdsMillisec = (inactivityThresholds * 60 * 1000) - 62000;
      if(!threshold){
      console.log("startTimer")
      threshold = InactivityThresholdsMillisec
    } else console.log("refreshedTimer: exipiring in" + (threshold/1000) + "sec" )
      // Attiva un nuovo timer
      if(this.user !== null){
        this.inactivityTimeout = setTimeout(() => {
        // Chiama il metodo di logout al termine del timer
        this.updateLastUserActivity(localStorage.getItem('lastActivity'));
        if((new Date(this.lastUserActivity).getTime() + (threshold ?? 0)) < new Date().getTime())
          this.toggleNearToLogout();
        else{
          threshold = (InactivityThresholdsMillisec ?? 0) - (new Date().getTime() - new Date(this.lastUserActivity).getTime())
          this.activateLogoutTimer(threshold);
        }
      },threshold);
      // tolgo 1 minuto e 2 secondi che saranno gestiti dalla modale di avviso logOut
    }
  }

  inactivityModalClose = (isActive : boolean = true) => {
    console.log("inactivityModalClick")
    runInAction(()=> {
      if(isActive)
      this.refreshActivity();
    })
    if(this.nearToLogout === true)
    this.toggleNearToLogout(false);
  }

  toggleNearToLogout = (value? : boolean) =>{
    value === false ? this.nearToLogout = value : this.nearToLogout = !this.nearToLogout;
  }

  refreshActivity = async () => {
    if(this.nearToLogout === true){
      localStorage.setItem('lastActivity', new Date().toISOString());
      var result = await agent.User.refreshActivity();
      if(result){
        console.log("refreshed")
        runInAction(()=> this.activateLogoutTimer())
      }
      else {
        runInAction(()=> this.logout(this.user?.logoutUrl))
      }
    }
  }

  updateLastUserActivity( value : string | null) {
    if(value)
    this.lastUserActivity = value;
  }
  login = async (values: IUserFormValues) => {
    try {
      const user = await agent.User.login(values);
      runInAction(() => {
        this.user = user;
        changePrincipalLanguage(user.languageId);
      });
      
      // this.rootStore.commonStore.setToken(user.token);
      // this.rootStore.tenantStore.startRefreshTokenTimer(user);
      history.push("/home");

      if (this.rootStore.commonStore.isNativeApp && user)
        await updateAppUser(user);
    } catch (error) {
      throw error;
    }
  };

  loginOtp = async (values: IOtpFormValues) => {
    try {
      const user = await agent.User.loginOtp(values);
      runInAction(() => {
        this.user = user;
        changePrincipalLanguage(user.languageId);
      });
      // this.rootStore.commonStore.setToken(user.token);
      // this.rootStore.tenantStore.startRefreshTokenTimer(user);
      history.push("/home");

      if (this.rootStore.commonStore.isNativeApp && user)
        await updateAppUser(user);
    } catch (error) {
      throw error;
    }
  };

  OtpRequest = async (values: IOtpFormValues) => {
    try {
      await agent.User.OtpRequest(values);
    } catch (error) {
      throw error;
    }
  };

  loginCustomStep1 = async (values: IUserFormValues) => {
    try {
      const res = await agent.User.loginCustomStep1(values);
      return res;
    } catch (error) {
      throw error;
    }
  };

  loginCustomStep2 = async (values: IOtpFormValues) => {
    try {
      const user = await agent.User.loginCustomStep2(values);
      runInAction(() => {
        this.user = user;
        changePrincipalLanguage(user.languageId);
      });
      // this.rootStore.commonStore.setToken(user.token);
      // this.rootStore.tenantStore.startRefreshTokenTimer(user);
      history.push("/home");

      if (this.rootStore.commonStore.isNativeApp && user)
        await updateAppUser(user);
    } catch (error) {
      throw error;
    }
  };

  register = async (values: RegistrationFormValues, confirmRegistration: boolean) => {
    try {
      // console.log("Registration");
      const user = await agent.User.register(values);
      runInAction(() => {
        // this.user = user;
      });
      if(confirmRegistration){
       
      setTimeout(() => {
        this.rootStore.authStore.showLoginForm(); // serve per resettare i valori e andare alla pagona di login
      }, 3000);
    }
    } catch (error) {
      
    toast.error("Error");
      throw error;
    }
  };

  resetPwd = async (values: IResetPwdFormValues) => {
    try {
      await agent.User.resetpwd(values);
    } catch (error) {
      throw error;
    }
  };

  confirmResetPwd = async (values: IUserConfirmResetPwdValues) => {
    try {
      await agent.User.confirmresetpwd(values);
      toast.success(getToastTranslation("password_reset_ok"));
    } catch (error) {
      toast.error(getToastTranslation("password_reset_error"));
      throw error;
    }
  };

  changePwd = async (values: IChangePwdFormValues) => {
    try {
      await agent.User.changePwd(values);
      runInAction(() => {
        this.isChangePwdOpen = false;
      });
      toast.success(getToastTranslation("password_update_ok"));
    } catch (error) {
      console.log(error);
      toast.error(getToastTranslation("password_update_error"));
      throw error;
    }
  };

  logout = async (path : string = "" ) => {
    // console.log("logOut_")
    const { leaveSession, toggleIsBroadcastControllerOpen, broadcastLauncherTypes } = this.rootStore.broadcastStore;
    const meeting = this.rootStore.playerStore.attendingMeeting;
    if (meeting) {
      await this.rootStore.tenantStore.leaveMeeting(meeting.id, false);
      this.rootStore.meetingStore.setSourceId(null);
    }
    if(broadcastLauncherTypes){
      await leaveSession();
      toggleIsBroadcastControllerOpen(false);
    }

    if (path!=="" && path!=null){
      try{
        const logoutMS = await agent.User.logOutSSO();
      
        runInAction(() => {
          this.user = null;
          this.rootStore.tenantStore.currentTenant = null;
          this.rootStore.tenantStore.stopSignalR();
        }) 

        console.log("redirect-microsoft");
        return logoutMS.url;
    
      } catch (error) {
        console.log(error);
      }
    }else{
      try{
        await agent.User.logout()
      } catch (error) {
        // anche se fallisce deve sloggare l'utente dal FE
        console.log(error);
      }

      //verificare se togliere la la runinaction dà problemi (controllare )
     
          runInAction( () => {
            this.rootStore.tenantStore.stopSignalR();
            this.user = null;
            this.rootStore.tenantStore.currentTenant = null;
          }); 

       setTimeout(() => {
        console.log("redirect Win home");
        window.location.href = "/";
      }, 3000); 
      // this.rootStore.commonStore.setToken(null);
    }
  };

  getUser = async () => {
    try {
      const user = await agent.User.current();
      runInAction(() => {
        this.user = user;
        changePrincipalLanguage(user.languageId);
      });
    } catch (error) {
      console.log(error);
    }
  };

  setIsChangePwdOpen = (value: boolean) => {
    this.isChangePwdOpen = value;
  };


  // METODI OBSOLETI ?

  get isCurrentUser() {
    if (this.rootStore.userStore.user && this.profile) {
      return this.rootStore.userStore.user.userName === this.profile.userName;
    } else {
      return false;
    }
  }

  loadProfile = async (userId: string) => {
    this.loadingProfile = true;
    try {
      const profile = await agent.User.details(userId);
      runInAction(() => {
        this.profile = profile;
        this.loadingProfile = false;
      });
      return profile;
    } catch (error) {
      runInAction(() => {
        this.loadingProfile = false;
      });
      console.log(error);
      toast.error(getToastTranslation("user_not_found_error"));
      history.push("/");
      throw error;
    }
  };

  updateMyProfile = async (profile: IUserProfileFormValues) => {
    try {
      await agent.User.updateCurrent(profile);
      toast.success(getToastTranslation("user_updated_ok"));
      return;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  resetProfile = () => {
    try {
      this.profile = null;
    } catch (error) {
      console.log(error);
    }
  };

  updateuserlanguage = async (language: number) => {
    try {
      await agent.User.updatelanguage(language);
    } catch (error) {
      throw error;
    }
  };

// AUTHENTICATOR APP
 loginAuthenticatorAppStep1 = async (values: IUserFormValues) => {
  try {
    
    if(!this.authenticatorAppResetToken){
     const res = await agent.User.loginAuthenticatorAppStep1(values);
      runInAction(() => this.loginAuthenticatorApp = res);
      return res;
    }else{
      
      values.token = this.authenticatorAppResetToken;
      const res = await agent.User.confirmDeleteAuthenticatorApp(values);
      runInAction(() => {
        this.authenticatorAppResetToken = ""
        this.loginAuthenticatorApp = res
      }
    );
      return res;
    }
   
  } catch (error) {
    throw error;
  }
};

getAuthenticatorQrcodeInfo = async (token: string, companyId : number) => {
try  {
    const res = await agent.User.getAuthenticatorAppInfo(token, companyId);
    runInAction(() => 
      this.authenticatorQRcodeInfo = res);
    return res;
  } catch (error) {
    throw error;
  } 

}

 loginAuthenticatorStep2 = async (values: IOtpFormValues) => {
try {
  const user = await agent.User.loginAuthenticatorStep2(values);
  runInAction(() => {
    this.user = user;
    changePrincipalLanguage( user.languageId );
  });
  history.push('/home');
} catch (error) {
  throw error;
}
};


 clearAuthenticatorInfo = () => {
 this.authenticatorQRcodeInfo = null;
}


 reset2FA_APP = async ( form: IAuthenticatorFormValues) => {
try {
    await agent.User.reset2FA_APP(form);
    toast.success(getToastTranslation("send_email_resetAuthenticatorApp"));
} catch (error) {
  toast.error(getToastTranslation("error"));
  throw error;
}

}

 setAuthenticatorAppResetToken = (token: string) => {
 this.authenticatorAppResetToken = token;
}
// fine AUTHENTICATOR APP

redirectToLogin = async () => {
  try {
    this.authenticatorQRcodeInfo = null;
    this.loginAuthenticatorApp = null;
    history.push('/home');
  } catch (error) {
    throw error;
  }
  };

}



